import firebase from 'firebase';

const stagingConfig = {
  apiKey: 'AIzaSyCPUBZez6CX82XgRucf-8kVanJt921hVfo',
  authDomain: 'kairos-app-staging.firebaseapp.com',
  databaseURL: 'https://kairos-app-staging.firebaseio.com',
  projectId: 'kairos-app-staging',
  storageBucket: 'kairos-app-staging.appspot.com',
  messagingSenderId: '484080059699'
};

const prodConfig = {
  apiKey: 'AIzaSyD4iMNN-99b1MEHHGyZOCG0c7H0uS_Vgg0',
  authDomain: 'kairos-app-production.firebaseapp.com',
  databaseURL: 'https://kairos-app-production.firebaseio.com',
  projectId: 'kairos-app-production',
  storageBucket: 'kairos-app-production.appspot.com',
  messagingSenderId: '1074545280235'
};

const isProd = process.env.REACT_APP_NODE_ENV === 'production';
const firebaseConfig = isProd ? prodConfig : stagingConfig;

export const localisationUrl = isProd
  ? 'https://us-central1-kairos-app-production.cloudfunctions.net/detectClient'
  : 'https://us-central1-kairos-app-staging.cloudfunctions.net/detectClient';
export const findDestisWithFaresUri = isProd
  ? 'https://us-central1-kairos-app-production.cloudfunctions.net/findDestisWithFaresAndWeather'
  : 'https://us-central1-kairos-app-staging.cloudfunctions.net/findDestisWithFaresAndWeather';

export const version = '1.10.9'; // !! match package.json version

firebase.initializeApp(firebaseConfig);
const db = firebase.database();
export const ref = db.ref();
export const connectedRef = db.ref('.info/connected');
export const firebaseAuth = firebase.auth;
export const firebaseUser = firebase.User;
export const timestamp = firebase.database.ServerValue.TIMESTAMP;

export const analyticsRef = ref.child('analytics');
export const usersRef = ref.child('users');
export const userStatsRef = ref.child('user-stats');
export const maintenanceModeRef = ref.child('maintenance-mode');
export const logsRef = ref.child('logs');
export const feedbackRef = ref.child('feedback');

export const refs = {
  usersRef,
  firebaseAuth,
  localisationUrl,
  feedbackRef,
  analyticsRef
};

// ref.child('weather-cache').remove();



// WEBPACK FOOTER //
// ./src/config.js